import comp from "./MultiSelectWithModal";
export default comp;
